import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DxSelectBoxModule } from 'devextreme-angular/ui/select-box';
import {DxTextBoxModule} from 'devextreme-angular/ui/text-box';
import { DxTemplateModule } from 'devextreme-angular';

import { DropdownComponent } from './dropdown.component';

@NgModule({
  imports: [CommonModule, DxSelectBoxModule, DxTextBoxModule, DxTemplateModule],
  declarations: [DropdownComponent],
  exports: [DropdownComponent]
})
export class DropdownModule { }
